import script from "./SourceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceSelector.vue?vue&type=script&setup=true&lang=js"

import "./SourceSelector.vue?vue&type=style&index=0&id=96c7580c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96c7580c"]])

export default __exports__